export default __webpack_public_path__ + "static/media/card-private-m.24db5494.jpg";